export const DEAL_SOURCE_WIN_WIRE = 'win_wire';
export const DEAL_SOURCE_PERFORMANCE_INDEX = 'performance_index';
